import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import ConflictDetails from '../terminalVisitForm/conflictdetails/ConflictDetails'

import './ConflictModal.scss'

const modalWidth = 350
const margin = 30

export default class ConflictModal extends PureComponent {
  static propTypes = {
    conflictModalDimensions: PropTypes.object,
    conflictModalConflicts: PropTypes.array
  }

  render() {
    if (!this.props.conflictModalDimensions || !this.props.conflictModalConflicts) {
      return null
    }

    // Determine if the conflicts modal should show on the left or the right side of the warning icon
    const showLeft = this.props.conflictModalDimensions.left - (modalWidth + margin) > 200
    const leftMargin = showLeft
      ? this.props.conflictModalDimensions.left - (modalWidth + margin)
      : this.props.conflictModalDimensions.left + margin

    const conflictModalStyle = {
      width: modalWidth,
      top: this.props.conflictModalDimensions.top - 10 + window.pageYOffset,
      left: leftMargin
    }

    return (
      <div className={`conflict-modal-wrapper ${showLeft ? 'left' : 'right'}`} style={conflictModalStyle}>
        <ConflictDetails conflicts={this.props.conflictModalConflicts} />
      </div>
    )
  }
}
